import $ from 'jquery';

import BaseLayoutView from 'app/src/views/base/BaseLayoutView';

import gatewayTerminalListView from './templates/gateway-terminal-list-view.hbs';

// events
const _Events = {
  ADD_TERMINAL_CLICKED: 'add:terminal:clicked',
  EDIT_TERMINAL_CLICKED: 'edit:terminal:clicked',
  EDIT_GATEWAY_CLICKED: 'edit:gateway:clicked',
};

// configure
let View = BaseLayoutView.extend({
  tagName: 'ul',
  className: 'gateway-listing',
  template: gatewayTerminalListView,

  ui: {
    addTerminalLink: 'a.add-terminal',
    editTerminalLink: 'a.edit-terminal',
    editGatewayLink: 'a.edit-gateway',
  },

  triggers: {
    'click @ui.addTerminalLink': _Events.ADD_TERMINAL_CLICKED,
  },

  events: {
    'click @ui.editTerminalLink': 'editTerminalClicked',
    'click @ui.editGatewayLink': 'editGatewayClicked',
  },
});

// define
export default class GatewayTerminalListView extends View {
  /**
   * Event handler for when Edit Gateway link is clicked.  Triggers an
   *
   * @param event {Event} The DOM event
   */
  editGatewayClicked(event) {
    let $el = $(event.target);

    this.trigger(_Events.EDIT_GATEWAY_CLICKED, $el.attr('gateway_id'));
  }

  /**
   * Event handler for when a terminal link is clicked.  Triggers an
   * event with the ID of the terminal that was clicked.
   *
   * @param event {Event} The DOM event
   */
  editTerminalClicked(event) {
    let $el = $(event.target);

    this.trigger(_Events.EDIT_TERMINAL_CLICKED, $el.attr('terminal_id'));
  }
}
